module.exports = __webpack_public_path__ + "static/avatar-5dbfe4d92023ea7b058905e8ed83c614.jpeg";